"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyEnumArray = exports.CurrencyEnum = void 0;
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["ALL"] = "ALL";
    CurrencyEnum["AMD"] = "AMD";
    CurrencyEnum["AZN"] = "AZN";
    CurrencyEnum["BYN"] = "BYN";
    CurrencyEnum["BAM"] = "BAM";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["GEL"] = "GEL";
    CurrencyEnum["ISK"] = "ISK";
    CurrencyEnum["MDL"] = "MDL";
    CurrencyEnum["RSD"] = "RSD";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CNY"] = "CNY";
    CurrencyEnum["HKD"] = "HKD";
    CurrencyEnum["NZD"] = "NZD";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["KRW"] = "KRW";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["INR"] = "INR";
    CurrencyEnum["RUB"] = "RUB";
    CurrencyEnum["ZAR"] = "ZAR";
    CurrencyEnum["TRY"] = "TRY";
    CurrencyEnum["BRL"] = "BRL";
    CurrencyEnum["TWD"] = "TWD";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["IDR"] = "IDR";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["CLP"] = "CLP";
    CurrencyEnum["PHP"] = "PHP";
    CurrencyEnum["AED"] = "AED";
    CurrencyEnum["COP"] = "COP";
    CurrencyEnum["SAR"] = "SAR";
    CurrencyEnum["MYR"] = "MYR";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["UGX"] = "UGX";
    CurrencyEnum["KES"] = "KES";
    CurrencyEnum["NGN"] = "NGN";
    CurrencyEnum["ARS"] = "ARS";
    CurrencyEnum["MUR"] = "MUR";
    CurrencyEnum["QAR"] = "QAR";
    CurrencyEnum["OMR"] = "OMR";
    CurrencyEnum["MKD"] = "MKD";
    CurrencyEnum["CRC"] = "CRC";
    CurrencyEnum["BWP"] = "BWP";
    CurrencyEnum["XOF"] = "XOF";
    CurrencyEnum["VND"] = "VND";
    CurrencyEnum["RWF"] = "RWF";
    CurrencyEnum["TND"] = "TND";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
exports.currencyEnumArray = Object.values(CurrencyEnum);
